import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useAuth } from "@/context/AuthContext";
import { useLocale } from "@/context/LocaleContext";

export default function Feed() {
  const { user } = useAuth();
  const { country } = useLocale();
  const { data: products = [], isLoading } = useQuery({
    queryKey: ["feed", country],
    queryFn: async () => (await api.get("/feed", { params: { country } })).data,
  });

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="flex items-center gap-2 text-[11px] tracking-luxe uppercase text-aura-accent mb-3">
        <Sparkles className="w-3.5 h-3.5" /> Curated for you
      </div>
      <h1 className="font-serif text-5xl tracking-tight mb-3">For You, {user?.name?.split(" ")[0]}</h1>
      <p className="text-sm text-aura-muted max-w-lg mb-12">
        A feed tuned to your taste{user?.profile?.style_preferences ? ` — ${user.profile.style_preferences}` : ""}.
        The more you shop and refine your profile, the sharper it gets.
      </p>

      {isLoading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[3/4] shimmer" />)}
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10" data-testid="feed-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
